import config from "config";
import { a, c } from "modules/plugins";
import { addRule } from "redux-ruleset";
import plugins from "plugins";
import * as ui from "../modules/ui";
import {
  addComponentToComponentList,
  alert,
  triggerSnackbarEvent,
  updateStory,
} from "./exportedPluginActions";

let clearAlertBoxCb: ((s: string) => void)[] = [];
addRule({
  id: "feature/OBSERVE_CLEAR_ALERT_BOX",
  target: ui.c.HIDE_MODAL,
  output: "#observe",
  consequence: (action: ui.a.HideModal) => {
    for (const cb of clearAlertBoxCb) cb(action.payload);
  },
});

addRule({
  id: "feature/SET_PLUGINS",
  target: "*",
  output: c.SET_PLUGIN_EVENTS,
  addOnce: true,
  condition: () => Boolean(config.plugins.length),
  consequence: (_, { getState }) => {
    let buffer = [];
    const state = getState();

    const actions = {
      alert: (ctx) => alert(state, clearAlertBoxCb, ctx),
      addComponentToComponentList: addComponentToComponentList,
      triggerSnackbarEvent: triggerSnackbarEvent,
      updateStory: updateStory,
    };

    for (let plugin of config.plugins) {
      let create = plugins[plugin.resolve];
      const feed = create(plugin.options, actions);
      buffer.push(...feed);
    }

    return a.setPluginEvents(buffer);
  },
});
